import _ from 'lodash';
import { COURSE_TAB } from '../../../native/containers/AppTabs/constants';
import {
  selectIsInTabs,
  selectCurrentTabName,
  makeSelectCurrentRouteInTab,
  defaultRouteForTab,
  selectCourseTabStackIsEmpty,
  selectPreviousRouteInTab,
} from './selectors';
import { trackTab } from '../../Analytics/TabTracking/dispatchers';

export const backToPreviousRoute = (tabName) => (dispatch, getState) => {
  const route = selectPreviousRouteInTab(tabName)(getState());
  let action = {
    type: route.type,
    meta: {
      direction: 'back',
    },
  };
  if (_.has(route, 'query')) {
    action = Object.assign({}, action, { query: route.query });
  }
  return dispatch(action);
};

export const popEntryOffCurrentStackNavigatorState = () => (
  dispatch,
  getState
) => {
  const state = getState();
  const isInTab = selectIsInTabs(state);
  const currentActiveTab = selectCurrentTabName(state);
  if (isInTab && currentActiveTab) {
    return dispatch(backToPreviousRoute(currentActiveTab));
  }
  return null;
};

export const switchToTab = (tabName) => (dispatch, getState) => {
  // We want to switch tabs, so lets work out what exact screen
  // we should end up on and what routing action we need
  const currentTab = selectCurrentTabName(getState());
  if (tabName === currentTab) {
    if (tabName !== COURSE_TAB) {
      return dispatch({
        type: defaultRouteForTab[tabName],
        meta: {
          // This is a special flag to indicate that when we navigate to this route, we should
          // reset the tab stack so that it contains only this route
          resetStack: true,
        },
      });
    } else {
      // back to one screen if it is course tab and not empty
      const isCourseTabEmpty = selectCourseTabStackIsEmpty(getState());
      if (!isCourseTabEmpty) {
        dispatch(backToPreviousRoute(tabName));
      }
    }
    return null;
  } else {
    // Tab tracking
    const destinationTab = tabName;
    dispatch(trackTab(currentTab, destinationTab));

    // There is already stuff in the stack for that tab,
    // so we should go back to where we were already without changing the stack
    const route = makeSelectCurrentRouteInTab(tabName)(getState());
    let action = {
      type: route.type,
      meta: {
        // This is kind of like RFRs `kind` except that it works for our tab stack reducer.
        // 'replace' means to replace the top entry in the stack - which does nothing because its the same entry!
        direction: 'replace',
      },
    };
    if (_.has(route, 'query')) {
      action = Object.assign({}, action, { query: route.query });
    }
    return dispatch(action);
  }
};
